import React, {useState, useEffect, useContext } from "react";
import { Box, Button,  CircularProgress, Divider, Stack, Tooltip} from "@mui/material";
import Application from "../../../components/application";
import MyPanel from "../../../components/myPanel";
import MyLabel from "../../../components/myLabel";
import MyInput from "../../../components/myInput";
import MyButton from "../../../components/myButton";
import { useNavigate, useParams } from "react-router-dom";
import useTemplateFormularioState from "../../../hooks/useTemplateFormularioState";
import MyCheckbox from "../../../components/myCheckbox";
import MyLoading from "../../../components/myLoading";
import MySelect from "../../../components/mySelect";
import Modal from '@mui/material/Modal';
import SecaoArea from "./secaoArea";
import PerguntaArea from "./perguntaArea";
import MessageDialog from "./messageDialog";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import ModalTemplateLista from "./modalTemplateLista";
import ModalConfiguraPergunta from "./modalConfiguraPergunta";
import TELAS from "../../../constants/telas";
import TELA_ACOES from "../../../constants/telaAcoes";
import permissaoTelas from "../../../utils/permissaoTelas";
import { AuthContext } from "../../../contexts/auth";

const PAGINA = {
    aplicacao: 'SisPalo - Tarefas',
    funcionalidade: 'Tarefas',
    tela: TELAS.TEMPLATE_TAREFAS,
    acoes: [TELA_ACOES.Incluir, TELA_ACOES.Consultar, TELA_ACOES.Alterar]
}



const ModalSecao = ({open, templateSecao, handleClose, handlerSalvar}) => {

    
    const [titulo, setTitulo] = useState(templateSecao.value.titulo)
    

    useEffect(()=>{setTitulo(templateSecao.value.titulo)},[templateSecao.value])

    return (
        <Modal
            open={open && templateSecao.value !== null}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            
            <Box sx={ {       
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '50%',
                height: '50%',
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                borderRadius:5,
                p: 4,}
                }>
                    <Box sx={{display:'flex', justifyContent:'end'}}>
                        <Button onClick={handleClose}>X</Button>
                    </Box>
                    <Box sx={{marginTop:'20px'}}>
                        <MyLabel sx={{ fontSize: "15pt", fontWeight: 600, color:'#000'}} 
                                component='h2' 
                                text={templateSecao.value && templateSecao.value.id ? 'Alterando Seção' : 'Cadastrando Seção'}/>
                    </Box>
                    <Box sx={{marginTop:'20px'}}>
                        <MyInput sx={{width:'100%'}} label='Titulo' type='text' value={titulo} onChange={(e)=>{
                            setTitulo(e.target.value)
                        }}/>
                        
                    </Box>
                    <Box sx={{flex:'flex', flexDirection:'row', marginTop:'20px'}}>
                        <MyButton  sx={{marginRight:'20px'}} onClick={handleClose} variant='contained' text='Cancelar' color='warning'/>
                        <MyButton onClick={()=>{
                            let _secao = {...templateSecao.value }
                            _secao.titulo = titulo
                            handlerSalvar(_secao)}} variant='contained' text='Salvar' color='primary'/>
                    </Box>
            </Box>
        </Modal> 
    )
}

const ModalPergunta = ({open, templateListas, templatePergunta, handleClose, handlerSalvar, modalLista, idLista}) => {
    
    useEffect(()=>{
        if (open){
            idLista.set(templatePergunta?.value.templatelista)
        }
    },[open])
    
    return (
        <Modal 
            open={open && templatePergunta?.value !== null}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            
            <Box sx={ {       
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '50%',
                height: '80%',
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                borderRadius:2,
                p: 4,}
                }>
                    <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                        <MyLabel sx={{ fontSize: "13pt", fontWeight: 600, color:'#000'}} component='h2' text={templatePergunta?.value && templatePergunta.value.id ? 'Alterando Pergunta' : 'Cadastrando Pergunta'}/>
                        <Button onClick={handleClose}>X</Button>
                    </Box>
                    <Divider/>
                    <Box sx={{display:'flex', flexDirection:'column', height:'95%', justifyContent:'space-between'}}>
                        <Box sx={{display:'flex', flexDirection:'column', gap:'15px', marginTop:'20px'}}>
                            <Box>
                                <MyInput 
                                    sx={{width:'100%'}}
                                    label='Descrição' type='text' value={templatePergunta?.value.descricao} onChange={(e)=>{
                                    let _pergunta = {...templatePergunta.value }
                                    _pergunta.descricao = e.target.value
                                    templatePergunta.set(_pergunta)
                                }}/>
                            </Box>

                            <Box>
                                <MyInput 
                                    sx={{width:'100%'}}
                                    InputProps={{inputProps: { min: 1 }}}
                                    onKeyDown={(e) => {
                                        if (e.key === '0' || e.key === '-' || e.key === 'Minus') {
                                        e.preventDefault(); 
                                        }
                                    }}
                                    label='Página' type='number' value={templatePergunta?.value.pagina} 
                                    onChange={(e)=>{
                                    const valor = parseInt(e.target.value, 10)
                                    if (isNaN(valor) || valor <= 0) return

                                    let _pergunta = {...templatePergunta.value }
                                    _pergunta.pagina = valor
                                    templatePergunta.set(_pergunta)
                                }}/>
                            </Box>

                            <Box>
                                <MySelect
                                    id='tipo'
                                    size="medium"
                                    label='Tipo Resposta'
                                    options={[ 
                                        {id:0, nome:'texto'},
                                        {id:1, nome:'condicional'},
                                        {id:2, nome:'opções'},
                                        {id:3, nome:'foto'},
                                        {id:4, nome:'assinatura'},
                                        {id:5, nome:'qrcode'}, 
                                        {id:6, nome:'data'} 
                                    ]}
                                    value={templatePergunta?.value.tipo_resposta}
                                    onChange={(e)=>{
                                        let _pergunta = {...templatePergunta.value }
                                        _pergunta.tipo_resposta = e.target.value
                                        if (e.target.value !== 2) {
                                            _pergunta.templatelista = null
                                        }
                                        templatePergunta.set(_pergunta)
                                    }}
                                    />
                            </Box>
                            {
                                templatePergunta?.value.tipo_resposta === 2 ?
                                
                                <Box sx={{
                                    display:'flex',
                                    width:'100%', 
                                    marginTop:'20px', 
                                }}>
                                        
                                        <Box sx={{width:'100%',}}>
                                            <MySelect
                                                id='tipo'
                                                size="medium"
                                                label='Lista de Opções'
                                                options={templateListas.value}
                                                value={templatePergunta?.value.templatelista}
                                                onChange={(e)=>{
                                                    let _lista = {...templatePergunta.value }
                                                    _lista.templatelista = e.target.value
                                                    templatePergunta.set(_lista)
                                                }}
                                                />
                                        </Box>
                                        <Box sx={{width:'50px', display:'flex', justifyContent:'center', alignItems:'center'}} >
                                            <Tooltip title={`Adicionar Lista`} arrow>
                                                <Button onClick={()=>{
                                                    idLista.set(null)
                                                    modalLista()
                                                }}><AddCircleOutlineIcon /></Button>
                                            </Tooltip>
                                        </Box>
                                        <Box sx={{width:'50px', display:'flex', justifyContent:'center', alignItems:'center'}}>
                                            <Tooltip title={`Editar Lista`} arrow>
                                                <Button disabled={templatePergunta.value.templatelista === null}
                                                    onClick={()=>{
                                                        idLista.set(templatePergunta?.value.templatelista)
                                                        modalLista()
                                                    }}><EditIcon/>
                                                </Button>
                                            </Tooltip>                                    
                                        </Box>
                                </Box> : <></>
                            }
                            <Box>
                                <MyCheckbox label='Visível' checked={templatePergunta?.value.visivel} onChange={(e)=> {
                                        let _pergunta = {...templatePergunta.value}
                                        _pergunta.visivel=!templatePergunta?.value.visivel
                                        templatePergunta.set(_pergunta)
                                    }}
                                />                        
                            </Box>
                            <Box>
                                <MyCheckbox label='Pergunta Obrigatória' checked={templatePergunta?.value.obrigatorio} onChange={(e)=> {
                                        let _pergunta = {...templatePergunta.value}
                                        _pergunta.obrigatorio= !templatePergunta?.value.obrigatorio
                                        templatePergunta.set(_pergunta)
                                    }}
                                />                        
                            </Box>
                        </Box>
                        <Box sx={{flex:'flex', flexDirection:'row'}}>
                            <MyButton  sx={{marginRight:'20px'}} onClick={handleClose} variant='contained' text='Cancelar' color='warning'/>
                            <MyButton onClick={()=>handlerSalvar()} variant='contained' text='Salvar' color='primary'/>
                        </Box>
                    </Box>
            </Box>
        </Modal> 
    )
}

const TemplateFormulario = () => {
    const navigate = useNavigate()
    
    const {permissaoUsuario, user} = useContext(AuthContext);    
    const states = useTemplateFormularioState()
    const { id } = useParams()

    const handleOpen = () => states.modalSecao.set(true);
    const handleClose = () => states.modalSecao.set(false);

    const handleOpenPerg = () => states.modalPergunta.set(true);
    const handleClosePerg = () => states.modalPergunta.set(false);    

    const handleOpenConfig = () => states.modalConfigPergunta.set(true);
    const handleCloseConfig = () => states.modalConfigPergunta.set(false);

    const handleOpenLista = () => states.modalLista.set(true);
    const handleCloseLista = () => states.modalLista.set(false);


    
    
    useEffect(()=>{
        if (permissaoTelas(permissaoUsuario, TELA_ACOES.Incluir, PAGINA)
            || permissaoTelas(permissaoUsuario, TELA_ACOES.Alterar, PAGINA)
        ) {
            if (id && id !== ''){
               states.submit.set(id)
            }
        }
        else{
            navigate('/gestor/dashboard');
            return;
        }
    }, [])

    useEffect(()=>{
            if (!states.templateFormulario.value?.tipotarefa?.editavel && !user.value.is_staff ) {
                navigate('/gestor/dashboard');
                return;
            }
    }, [states.templateFormulario.value])
 
    return (
        <Application>
            <MyPanel >
                <MyLoading render={states.submit.value}/>  
                <Stack spacing={5} >
                    <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
                        <MyLabel component='h1' text = {`Template Tarefa`}/>
                       { user.value.is_staff ?
                        <MyCheckbox
                            label='Editável'
                            disabled={false}
                            checked={states.templateFormulario.value?.tipotarefa?.editavel}
                            onChange={()=> {
                                let _templateFormulario = {...states.templateFormulario.value}
                                _templateFormulario.tipotarefa.editavel = !_templateFormulario.tipotarefa.editavel
                                states.templateFormulario.set(_templateFormulario)
                            }}
                        />
                        : <></>
                        }
                    </Box>
                    <Box>
                        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
                            <MyInput sx={{width:'100%', marginRight: 2}} size="small" label='Nome Template Tarefa' type='text' value={states.templateFormulario.value?.tipotarefa?.nome} onChange={(e)=>{
                                let _templateFormulario = {...states.templateFormulario.value}
                                _templateFormulario.tipotarefa.nome = e.target.value
                                states.templateFormulario.set(_templateFormulario)
                                
                            }}/>
                            <MyCheckbox
                                label='Ativo'
                                disabled={false}
                                checked={states.templateFormulario.value?.tipotarefa?.ativo}
                                onChange={()=> {
                                    let _templateFormulario = {...states.templateFormulario.value}
                                    _templateFormulario.tipotarefa.ativo = !_templateFormulario.tipotarefa.ativo
                                    states.templateFormulario.set(_templateFormulario)
                                }}
                            />

                        </Box>
                        <Box style={{display:'flex', flexDirection:'row', gap:'10px', marginTop:2, justifyContent:'space-between'}}>
                            <MyCheckbox
                                label='Tem Formulário'
                                disabled={states.templateSecoes.value?.length>0}
                                checked={states.templateFormulario.value?.tipotarefa?.tem_formulario}
                                onChange={()=> {
                                    let _templateFormulario = {...states.templateFormulario.value}
                                    _templateFormulario.tipotarefa.tem_formulario = !_templateFormulario.tipotarefa.tem_formulario
                                    states.templateFormulario.set(_templateFormulario)
                                }}
                            />
                            <MyCheckbox
                                label='Finaliza Tarefa com QrCode'
                                disabled={false}
                                checked={states.templateFormulario.value?.tipotarefa?.finaliza_com_qrcode}
                                onChange={()=> {
                                    let _templateFormulario = {...states.templateFormulario.value}
                                    _templateFormulario.tipotarefa.finaliza_com_qrcode = !_templateFormulario.tipotarefa.finaliza_com_qrcode
                                    states.templateFormulario.set(_templateFormulario)
                                }}
                            />
                        </Box>
                        <Box sx={{display:'flex', marginTop: 2 , justifyContent:'space-between'}}>
                            <MyButton color='warning' onClick={()=> navigate('/gestor/template')} variant='contained' text='Cancelar'/>
                            <MyButton sx={{marginRight:1}} color='success' onClick={states.templateFormulario.value?.id  && states.templateFormulario.value?.id > 0 ? states.templateFormularioPut.set : states.templateFormularioPost.set}variant='contained' text={states.templateFormulario.value?.id  && states.templateFormulario.value?.id > 0 ? 'Alterar' : 'Cadastrar'} />
                        </Box>
                    </Box>
                    {
                        states.templateFormulario.value  && states.templateFormulario.value?.tipotarefa?.tem_formulario ?
                            <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-between', gap:"40px"}}>
                                <Box sx={{width:'70%'}} >
                                    {
                                        //gridArea Seção
                                        states.submitTemplateSecoes.value ? 
                                            <CircularProgress color="primary" />
                                        
                                        : <SecaoArea 
                                                dialog={()=>states.dialogDeleteSecao.set(true)} 
                                                templateFormulario={states.templateFormulario.value} 
                                                templateSecoes={states.templateSecoes} 
                                                templateSecao={states.templateSecao} 
                                                modal={handleOpen}
                                                />
                                        
                                    }
                                </Box>
                                <Box sx={{width:'100%'}} >
                                    {
                                        //gridArea de perguntas
                                        states.submitTemplatePerguntas.value ? 
                                            <CircularProgress color="primary"/>
                                        :  
                                            states.templateSecao.value && states.templateSecoes.value.length>0 ?
                                            <PerguntaArea 
                                                    dialog={()=>states.dialogDeletePergunta.set(true)} 
                                                    templateSecao={states.templateSecao.value} 
                                                    templatePerguntas={states.templatePerguntas} 
                                                    templatePergunta={states.templatePergunta} 
                                                    modal={handleOpenPerg}
                                                    modalConfig={handleOpenConfig}
                                                    />
                                        : <></>
                                    }
                                </Box>
                            </Box>
                        :
                            <></>
                    }
                                       
                </Stack>

                {
                    states.templateSecao.value ?
                        <ModalSecao 
                            open={states.modalSecao.value} 
                            handleClose={handleClose} 
                            templateSecao={states.templateSecao} 
                            handlerSalvar={(secao)=>{
                                states.salvarSecao.set(secao, handleClose)
                            }}
                        />
                    : <></>
                }
                {
                    states.templatePergunta.value ?
                        <ModalPergunta 
                            open={states.modalPergunta.value} 
                            handleClose={handleClosePerg} 
                            templatePergunta={states.templatePergunta} 
                            templateListas={states.templateListas}
                            modalLista={handleOpenLista}
                            idLista={states.idLista}
                            handlerSalvar={()=>{
                                states.salvarPergunta.set(handleClosePerg)
                            }}
                        />
                    : <></>
                }

                {
                    states.templatePergunta.value ?
                        <ModalConfiguraPergunta 
                                open={states.modalConfigPergunta.value} 
                                handleClose={handleCloseConfig} 
                                template={states.templatePergunta} 
                                templatePerguntas={states.templatePerguntas} 
                                handlerSalvar={()=>{
                                    states.salvarPergunta.set(handleCloseConfig)
                                }}
                            />                
                    :<></>
                }
                {
                    <ModalTemplateLista 
                                    open={states.modalLista.value}
                                    handleClose={handleCloseLista}
                                    id={states.idLista.value}
                                    />

                }

                <MessageDialog 
                    frase = {`Você quer apagar a seção: ${states.templateSecao.value?.titulo}`}
                    open={states.dialogDeleteSecao.value}
                    handlerSalvar={()=>states.apagarSecao.set(()=>states.dialogDeleteSecao.set(false))} 
                    handleClose={()=>states.dialogDeleteSecao.set(false)} />    


                <MessageDialog 
                    frase = {`Você quer apagar a Pergunta: ${states.templatePergunta.value?.descricao}`}
                    open={states.dialogDeletePergunta.value}  
                    handlerSalvar={()=>states.apagarPergunta.set(()=>states.dialogDeletePergunta.set(false))} 
                    handleClose={()=>states.dialogDeletePergunta.set(false)} />    

            </MyPanel>
        </Application>

    )
}

export default TemplateFormulario;